export const LOCAL_STORAGE_KEY = {
  THEME: "theme",
};

export const THEME = {
  DARK: "dark",
  LIGHT: "light",
};

export const WEB3_MODAL_STATUUS = {
  RECONNECTING: "reconnecting",
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
};

export const TOAST_ID = {
  CONNECT_WALLET: 1,
  CORRECT_NETWORK: 2,
  ADMIN_WALLET: 3,
  FILE_EXTENSION: 4,
  GETTING_ALLOWANCE: 5,
  GETTING_STAKING: 6,
};

export const METAMASK_ERROR_CODE = {
  USER_REJECT: "ACTION_REJECTED",
};

export const REQUEST_TYPE = {
  CREATE_ALLOWANCE: "CREATE_ALLOWANCE",
  REMOVE_ALLOWANCE: "REMOVE_ALLOWANCE",
  IMPORT_ALLOWANCE: "IMPORT_ALLOWANCE",
};
